// Mobile product gallery thumbnails: tapping a thumb scrolls the swipeable
// gallery to that media, and swiping the gallery marks the matching thumb.
// Listeners are delegated on document so they survive the product-gallery
// partial being replaced on variant change.

function galleryFor(el) {
  return el.closest('[data-product-gallery-root]')?.querySelector('[data-product-gallery]');
}

function markActive(root, mediaId) {
  root.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
    const active = thumb.dataset.galleryThumb === mediaId;
    thumb.toggleAttribute('data-active', active);
    if (active) thumb.setAttribute('aria-current', 'true');
    else thumb.removeAttribute('aria-current');
  });
}

document.addEventListener('click', (event) => {
  const thumb = event.target.closest('[data-gallery-thumb]');
  if (!thumb) return;
  const gallery = galleryFor(thumb);
  const item = gallery?.querySelector(`[data-gallery-item="${thumb.dataset.galleryThumb}"]`);
  if (!gallery || !item) return;
  const left = item.getBoundingClientRect().left - gallery.getBoundingClientRect().left + gallery.scrollLeft;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  gallery.scrollTo({ left, behavior: reduce ? 'auto' : 'smooth' });
  markActive(thumb.closest('[data-product-gallery-root]'), thumb.dataset.galleryThumb);
});

let frame = 0;
document.addEventListener(
  'scroll',
  (event) => {
    const gallery = event.target;
    if (!(gallery instanceof Element) || !gallery.matches('[data-product-gallery]')) return;
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      const center = gallery.getBoundingClientRect().left + gallery.clientWidth / 2;
      let closest = null;
      let distance = Infinity;
      gallery.querySelectorAll('[data-gallery-item]').forEach((item) => {
        const rect = item.getBoundingClientRect();
        const d = Math.abs(rect.left + rect.width / 2 - center);
        if (d < distance) {
          distance = d;
          closest = item;
        }
      });
      const root = gallery.closest('[data-product-gallery-root]');
      if (closest && root) markActive(root, closest.dataset.galleryItem);
    });
  },
  true
);

// Color/variant change: move the chosen variant's photo to the front of the
// gallery and the thumbnail strip, then bring the gallery back to its start.
function showVariantMedia(variantId) {
  const root = document.querySelector('[data-product-gallery-root][data-variant-media]');
  if (!root) return;
  const map = Object.fromEntries(
    root.dataset.variantMedia.split(',').map((pair) => pair.split(':'))
  );
  const mediaId = map[variantId];
  if (!mediaId) return;
  root.querySelectorAll('[data-gallery-item], [data-gallery-thumb]').forEach((el) => {
    const id = el.dataset.galleryItem || el.dataset.galleryThumb;
    el.classList.remove('order-first');
    el.style.order = id === mediaId ? '-1' : '';
  });
  const gallery = root.querySelector('[data-product-gallery]');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  gallery?.scrollTo({ left: 0, behavior: reduce ? 'auto' : 'smooth' });
  root.querySelector('[data-gallery-thumb]')?.parentElement?.scrollTo({ left: 0 });
  markActive(root, mediaId);
  // On desktop the gallery is a grid; bring its top into view if it scrolled away.
  if (window.matchMedia('(min-width: 768px)').matches && root.getBoundingClientRect().top < 0) {
    root.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  }
}

document.addEventListener('change', (event) => {
  const input = event.target;
  if (!(input instanceof Element) || !input.closest('[data-product-form]')) return;
  const variantId = input.dataset?.variantId || input.selectedOptions?.[0]?.dataset?.variantId;
  if (variantId) showVariantMedia(variantId);
});
